import React, { useState } from 'react';
import { ChevronDownIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
const TESTIMONIALS = [{
  quote: 'Mi hijo me preguntó por qué siempre le mandaba lo mismo. Compré el MEGAPACK ese domingo. Hoy me pide la etiqueta del jueves porque es su favorita. Se come todo.',
  author: 'Valentina G.',
  loc: 'Montevideo · Mamá de 9 años',
  initials: 'VG'
}, {
  quote: 'La lonchera volvía siempre llena. Yo llegaba al trabajo con esa imagen en la cabeza. Desde que uso el sistema mi hijo come todo y yo por fin trabajo tranquila.',
  author: 'Marcela F.',
  loc: 'Rivera · Mamá de 7 años',
  initials: 'MF'
}, {
  quote: 'Está organizado por situación real y adaptado a Uruguay. Los precios, las frutas de temporada, todo. Es como tener una amiga que ya hizo el trabajo por mí.',
  author: 'Roberto B.',
  loc: 'Salto · Papá de 8 años',
  initials: 'RB'
}, {
  quote: 'El tomo de meriendas económicas me cambió la semana. Ahora gasto menos, mando más variedad y mi hijo vuelve con la lonchera vacía.',
  author: 'Carolina P.',
  loc: 'Canelones · Mamá de 6 años',
  initials: 'CP'
}, {
  quote: 'Esa sensación de que no podés resolver algo tan simple es horrible. Todos los días. Este MEGAPACK me la sacó. Es completamente verdad.',
  author: 'Laura M.',
  loc: 'Montevideo · Mamá de 5 años',
  initials: 'LM'
}, {
  quote: 'Ahora soy yo el que organiza los domingos. Funciona, es fácil, y mi hija llega feliz al recreo.',
  author: 'Fernando R.',
  loc: 'Ciudad de la Costa · Papá de 10 años',
  initials: 'FR'
}];
const FAQS = [['¿Funciona si mis hijos son muy selectivos con la comida?', 'Sí. El Tomo 6 incluye una guía específica para meriendas que vuelven vacías y estrategias para involucrar al niño en la elección. Cuando el niño elige, come.'], ['¿Es solo un recetario?', 'No. Es un sistema de planificación completo: recetas, planificadores, un banco de 60 ideas, listas de compras, estrategias de ahorro y herramientas para organizar un mes entero.'], ['¿Está adaptado a Uruguay o es material genérico?', 'Está creado específicamente para Uruguay. Los ingredientes, precios orientativos, guía de frutas por temporada y referencias son 100% uruguayas.'], ['¿Necesito saber cocinar?', 'No. La mayoría de las 60 meriendas del banco no requieren cocinar. Las recetas del Tomo 4 están pensadas para personas sin experiencia: simples, rápidas y con ingredientes cotidianos.'], ['¿Cómo recibo el MEGAPACK?', 'De forma inmediata. Apenas completás el pago recibís el link de descarga por WhatsApp o email.'], ['¿Funciona para familias con más de un hijo?', 'Sí. El sistema es escalable para uno o varios hijos con distintos gustos y edades.'], ['¿Es editable?', 'Está en PDF. Los planificadores y listas están diseñados para completar a mano o en pantalla.'], ['¿Qué pasa si no es lo que esperaba?', 'Tenés 7 días de garantía total. Si aplicás el sistema y sentís que no te ayudó, te devolvemos el dinero sin preguntas.']];
export function TestimonialsAndFaq() {
  return <>
      <section className="bg-brand-lightBlue px-4 py-20" data-id="element-237" data-mp="3gb6lond0d2qt">
        <div className="mx-auto max-w-5xl" data-id="element-238" data-mp="3kcs5ksnymhai">
          <header className="text-center" data-id="element-239" data-mp="3kbqjlt5eoae0">
            <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-240" data-mp="2nm9g9ktwb0fh">
              Testimonios completos
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-241" data-mp="2slc9m80iji7m">
              Esto dicen las familias sobre Meriendas que Acompañan
            </h2>
          </header>
          <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-242" data-mp="31ep9xv0wpm3q">
            {TESTIMONIALS.map(testimonial => <article key={testimonial.initials} className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm" data-id="element-243" data-mp="24tfanhi5wknx">
                <div className="flex text-yellow-400" aria-label="5 de 5 estrellas" data-id="element-244" data-mp="1pt9taf93rcl6">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-5 w-5 fill-current" data-id="element-245" data-mp="1url1kljr1f1a" data-mpi={index} />)}
                </div>
                <p className="mt-4 text-lg font-medium leading-relaxed text-brand-text" data-id="element-246" data-mp="28ipwxbg33l5t">
                  “{testimonial.quote}”
                </p>
                <div className="mt-6 flex items-center gap-4" data-id="element-247" data-mp="23jdb8u0y8k4t">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-blue font-bold text-white" data-id="element-248" data-mp="2ihfet47zd5m2">
                    {testimonial.initials}
                  </span>
                  <span data-id="element-249" data-mp="o2crnd6elzmb">
                    <strong className="block text-brand-deep" data-id="element-250" data-mp="o3xpbbo0lyoe">
                      {testimonial.author}
                    </strong>
                    <small className="text-brand-gray" data-id="element-251" data-mp="j6eaoanenjvx">{testimonial.loc}</small>
                  </span>
                </div>
              </article>)}
          </div>
        </div>
      </section>
      <section className="bg-brand-greenSoft px-4 py-20 text-center" data-id="element-252" data-mp="2l1lgf594gjzg">
        <div className="mx-auto max-w-2xl" data-id="element-253" data-mp="2l1bpnfg968sp">
          <ShieldCheckIcon className="mx-auto h-20 w-20 text-brand-green" data-id="element-254" data-mp="2q0esct8rg2xi" />
          <h2 className="mt-6 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-255" data-mp="2pybx9usr3jlx">
            GARANTÍA TOTAL DE 7 DÍAS
          </h2>
          <p className="mt-6 text-xl font-medium leading-relaxed text-brand-text" data-id="element-256" data-mp="2g3jy4mjisop1">
            Usalo esta semana entera. Probá el sistema con tus hijos. Mandá
            meriendas diferentes todos los días.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-brand-text" data-id="element-257" data-mp="272cbj1qd9cas">
            Si en 7 días esa pregunta sigue siendo igual de dolorosa, te
            devolvemos el dinero completo. Sin preguntas. Sin formularios. Sin
            vueltas.
          </p>
          <div className="mt-8 grid gap-3 rounded-2xl border border-green-200 bg-white p-5 text-left text-sm font-medium text-brand-text sm:grid-cols-2" data-id="element-258" data-mp="3ttk6cmbe5m1">
            <p data-id="element-259" data-mp="3uya6xdak6ci9">🛡️ 7 días desde la compra</p>
            <p data-id="element-260" data-mp="3pzyviy4m7txx">📋 Que hayas intentado aplicarlo</p>
            <p data-id="element-261" data-mp="3q0qpy5mh7lmm">💬 Escribinos por WhatsApp o Instagram</p>
            <p data-id="element-262" data-mp="3l274s7fpidvb">⚡ Devolución en 48 horas hábiles</p>
          </div>
          <p className="mt-7 italic text-brand-text" data-id="element-263" data-mp="mjs2dljttf3e">
            “Ofrecemos esta garantía porque sabemos que el sistema funciona
            cuando se aplica.”
          </p>
          <p className="mt-2 font-bold text-brand-deep" data-id="element-264" data-mp="hlgq74626si0">
            — Equipo Tu Fénix Digital 🐦‍🔥
          </p>
        </div>
      </section>
      <section className="bg-white px-4 py-20" data-id="element-265" data-mp="7vf4gj16hm69">
        <div className="mx-auto max-w-3xl" data-id="element-266" data-mp="7ult14r9y8hs">
          <h2 className="text-center font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-267" data-mp="159zrgzqoy50l">
            ❓ Preguntas Frecuentes
          </h2>
          <div className="mt-10 space-y-4" data-id="element-268" data-mp="10hzxdnxay6bx">
            {FAQS.map(([question, answer]) => <FaqItem key={question} question={question} answer={answer} data-id="element-269" data-mp="18trrhogngmf7" />)}
          </div>
        </div>
      </section>
    </>;
}
function FaqItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <article className="overflow-hidden rounded-xl border border-slate-200 bg-white" data-id="element-270" data-mp="1mszs8lsgo2li">
      <button type="button" onClick={() => setIsOpen(current => !current)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-sky" data-id="element-271" data-mp="1rrunin7m7jmi">
        <span className="font-bold text-brand-deep" data-id="element-272" data-mp="25ipntb41sseh">{question}</span>
        <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-gray transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-273" data-mp="2ahj2v7yzgrgr" />
      </button>
      {isOpen && <div data-id="element-274" data-mp="2fej8xivu1u7v">
          <p className="px-6 pb-5 leading-relaxed text-brand-text" data-id="element-275" data-mp="2fe9f1k7o32ww">{answer}</p>
        </div>}
    </article>;
}